import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useResponsive from 'src/lib/hooks/useResponsive';
import TrackingManager from 'src/lib/managers/TrackingManager';
import { getIsBackToTop } from 'src/lib/redux/modules/settings';

const ScrollFlow = () => {
	const responsive = useResponsive();
	const backToTop = useSelector(state => getIsBackToTop(state.settings));
	const scrollArr = [0];
	let breakpoint;
	let spaceBetweenBreakpoints;
	let rowHeight = 340;
	let totalRowsScrolledDown = 0;
	let lowestScrollingPointPixels = 0;
	let currentRow = 0;
	let rowsScrolled = 0;
	let pixelsScrolled = 0;
	let lastScroll = 0;
	let scrollingDown = true;

	breakpoint = spaceBetweenBreakpoints = responsive.isMobile ? 660 : 680;
	rowHeight = responsive.isMobile ? 330 : 340;

	const scrollHandler = () => {
		var scroll = window.pageYOffset;

		currentRow = Math.round(scroll / rowHeight);
		pixelsScrolled = Math.abs(scroll - scrollArr[scrollArr.length - 1]);
		rowsScrolled = Math.round(pixelsScrolled / rowHeight);

		if (totalRowsScrolledDown < currentRow) {
			totalRowsScrolledDown = currentRow;
		}

		if (lowestScrollingPointPixels < scroll) {
			lowestScrollingPointPixels = scroll;
		}

		if (scroll > lastScroll) {
			// scroll down
			if (!scrollingDown) {
				scrollingDown = !scrollingDown;
				scrollArr.push(scroll);
			}

			if (scroll >= breakpoint) {
				breakpoint += spaceBetweenBreakpoints;
			}
		} else {
			//scroll up
			if (scrollingDown) {
				scrollingDown = !scrollingDown;
				scrollArr.push(scroll);
			}
			if (scroll < breakpoint - spaceBetweenBreakpoints) {
				const eventData = {
					eventValueInteger4: rowsScrolled,
					eventValueInteger5: pixelsScrolled,
					eventValueInteger7: totalRowsScrolledDown,
					eventValueInteger8: lowestScrollingPointPixels,
				};
				if (!backToTop) {
					TrackingManager.trackEvent('Scroll Up', eventData);
				}
				breakpoint -= spaceBetweenBreakpoints;
			}
		}

		lastScroll = scroll <= 0 ? 0 : scroll;
	};

	useEffect(() => {
		window.addEventListener('scroll', scrollHandler);

		return () => {
			window.removeEventListener('scroll', scrollHandler);
		};
	}, [backToTop]);

	return null;
};

export default ScrollFlow;
